export interface UpsellOrderRequest {
  account_id: number;
  cdr_product_ids: number[];
  comment?: string;
  user_id: number;
}

export interface UpsellOrderResponse {
  order_ids: number[];
  account_id: number;
}

export interface UpsellProductDetails {
  id: number;
  name: string;
  price: number;
  type: string;
  commission: number;
}

export interface ZendeskTicket {
  subject: string;
  description: string;
  group_id: number;
  tags: string[];
}

export interface UpsellOrderActivityLog {
  agent_name: string;
  ticket_id: string;
  message: string;
}

export class UpsellOrderModel {
	account_id: number;
	cdr_product_ids: number[];
	comment?: string;
	user_id: number;

	constructor(account_id: number, user_id: number, comment?: string) {
		this.account_id = account_id;
		this.user_id = user_id;
		this.comment = comment || '';
		this.cdr_product_ids = [];
	}

	addProduct(cdrProductId: number): void {
		// Add the cdr_product_id if it doesn't already exist
		if (!this.cdr_product_ids.includes(cdrProductId)) {
			this.cdr_product_ids.push(cdrProductId);
		}
	}

	removeProduct(cdrProductId: number): void {
		// Remove the cdr_product_id if it exists
		this.cdr_product_ids = this.cdr_product_ids.filter(id => id !== cdrProductId);
	}

	clearProducts(): void {
		this.cdr_product_ids = [];
	}

	updateUpsellOrder(updates: Partial<UpsellOrderRequest>): void {
		if (updates.account_id !== undefined) {
			this.account_id = updates.account_id;
		}
		if (updates.user_id !== undefined) {
			this.user_id = updates.user_id;
		}
		if (updates.comment !== undefined) {
			this.comment = updates.comment;
		}
		if (updates.cdr_product_ids !== undefined) {
			this.cdr_product_ids = [...updates.cdr_product_ids];
		}
	}

	getRequestObject(): UpsellOrderRequest {
		return {
			account_id: this.account_id,
			cdr_product_ids: this.cdr_product_ids,
			comment: this.comment ?? '',
			user_id: this.user_id,
		};
	}
}